<script lang="ts">
    import type { Product } from "../model";
    export let product: Product;
    export let customClasses: string[] = [];
</script>

<div id="product-price" class={customClasses.join(" ")}>
    <div id="first-product">
        <div id="price">
            {#if product.price !== "" && Number(product.price) > 0}
                <div class="price-deci">
                    {Number(product.price).toFixed(2).split(".")[0]}
                </div>
                <div class="right-part">
                    <div class="price-euro">€</div>
                    <div class="price-cents">
                        ,{Number(product.price).toFixed(2).split(".")[1]}
                    </div>
                </div>
            {/if}
        </div>
        {#if product.meca == "meca3"}
            <div id="PackagingType">Le 1<sup>er</sup> produit</div><br>
        {/if}
    </div>

    {#if product.meca == "meca3"}
    <div id="second-product">
        <div id="price">
            {#if product.discountedPriceSecondProduct !== "" && Number(product.discountedPriceSecondProduct) > 0}
                <div class="price-deci">
                    {Number(product.discountedPriceSecondProduct).toFixed(2).split(".")[0]}
                </div>
                <div class="right-part">
                    <div class="price-euro">€</div>
                    <div class="price-cents">
                        ,{Number(product.discountedPriceSecondProduct).toFixed(2).split(".")[1]}
                    </div>
                </div>
            {/if}
        </div>
        {#if product.meca == "meca3"}
            <div id="PackagingType">Le {product.discountPriceQty}<sup>e</sup> produit</div><br>
        {/if}
    </div>
    {/if}
</div>

<style lang="scss">
    @import "../styles/variables.scss";

    #product-price {
        float: left;
        width: 100%;
        display: flex;
        flex-direction: row;
        gap: 1;
        flex-wrap: wrap;

        * {
            font-family: "Diagramm Bold" !important;
            font-weight: normal;
            color: black;
            float: left;
        }

        #ref_price {
            font-weight: normal;
            font-size: 11px;
            line-height: 9px;
            text-transform: uppercase;
            text-align: left;
            &.mt25 {
                margin-top: 25px;
            }
        }

        .advantage_price {
            float: initial;
            line-height: 0;
            margin-left: -4px;
            font-weight: bold;
            text-decoration: none;
        }

        #first-product,
        #second-product {
            display: flex;
            flex-direction: column;
            // width: 100%;
            line-height: 0;
            &.w-50 {
                width: auto;
                max-width: 50%;
            }

            #init-price {
                font-size: 11px;
                line-height: 11px;
                width: 100%;
                text-align: left;
                p {
                    &.barre {
                        text-decoration: line-through;
                    }
                }
                sup {
                    margin-left: 2px;
                }
            }

            #price {
                float: left;
                // width: 100%;
                line-height: 38px;
                .price-deci {
                    font-size: 38px;
                }
                .right-part {
                    display: inline-block;
                    text-align: left;
                    line-height: 14px;
                    .price-euro {
                        display: block;
                        float: left;
                        width: 100%;
                        font-size: 20px;
                        margin-top: 4px;
                    }
                    .price-cents {
                        display: block;
                        float: left;
                        width: 100%;
                        font-size: 17px;
                    }
                }
            }

            #PackagingType,
            #ecotaxe {
                // width: 100%;
                font-size: 9px;
                line-height: 10px;
                text-transform: initial;
                letter-spacing: 0;
                font-family: "Roboto" !important;
                text-align: left;
                sup {
                    float: initial;
                }
            }

            #priceFrom {
                width: 100%;
                font-size: 7px;
                line-height: 10px;
                text-transform: initial;
                // font-weight: bold;
                letter-spacing: 0;
                font-family: "Roboto" !important;
                text-align: left;
            }

            #lowerprice {
                width: 100%;
                margin-top: 1em;
            }
        }

        #second-product {
            margin-left: 10px;
        }
    }
</style>
